import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "swiper swiper-container",
  ref: "swiperNav"
};
const _hoisted_2 = {
  class: "swiper-wrapper"
};
const _hoisted_3 = {
  class: "swiper-image swiper-slide"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "listwrap"
};
const _hoisted_6 = {
  class: "eName"
};
const _hoisted_7 = {
  class: "list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "name"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "name"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "name"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 0,
  class: "finishedText"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "guideList",
    style: _normalizeStyle({
      '--guideThemeColor': $options.guideThemeColor
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.image, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_4)]);
  }), 256))]), _cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "slide-pagination"
  }, null, -1))], 512), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($data.detail.name), 1), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.realList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`item ${!$data.realList.find(r => {
        return r.children?.length;
      }) ? '' : 'more'} ${item.showMore ? 'showMoreItem' : ''}`),
      onClick: $event => $options.toDetail(item)
    }, [_createElementVNode("img", {
      src: item.image[0]
    }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [!$data.realList.find(r => {
      return r.children?.length;
    }) ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(index + 1), 1)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.explainObj), 1)]), item.children && item.children.length ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList(item.children, (item2, index2) => {
      return _openBlock(), _createElementBlock("div", {
        class: "item2",
        onClick: _withModifiers($event => $options.toDetail(item2), ["stop"])
      }, [_createElementVNode("img", {
        src: item2.image[0]
      }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(index2 + 1), 1), _createTextVNode(" " + _toDisplayString(item2.explainObj), 1)]), item2.children && item2.children.length && item.showMore ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(item2.children, item3 => {
        return _openBlock(), _createElementBlock("div", {
          class: "item3",
          onClick: _withModifiers($event => $options.toDetail(item3), ["stop"])
        }, [_createElementVNode("img", {
          src: item3.image[0]
        }, null, 8, _hoisted_16), _createElementVNode("div", _hoisted_17, _toDisplayString(item3.explainObj), 1)], 8, _hoisted_15);
      }), 256)) : _createCommentVNode("", true)], 8, _hoisted_12);
    }), 256)) : _createCommentVNode("", true), $data.realList.find(r => {
      return r.children?.length;
    }) && item.length > 3 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: _normalizeClass(`moreText ${item.showMore ? 'showMore' : ''}`),
      onClick: _withModifiers($event => item.showMore = !item.showMore, ["stop"])
    }, _toDisplayString(item.showMore ? '收起' : '展开'), 11, _hoisted_18)) : _createCommentVNode("", true)], 10, _hoisted_8);
  }), 256)), $data.finished ? (_openBlock(), _createElementBlock("div", _hoisted_19, "--已经到底了--")) : _createCommentVNode("", true)])])], 4);
}